var _excluded = ["name", "width", "height", "color", "className", "viewBox", "data-qa", "size", "x", "y", "iconsAlternativeConfig", "iconsSizesConfig"];
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable prefer-destructuring */
/* eslint-disable custom-rules/need-data-qa */
import React from "react";
import IconBase from "./IconBase";
import { iconSizes, sizes, defaultSizes } from "./iconSizes";
import { iconsAlternative } from "./iconsAlternative";
var getCoordinate = (wrapperSize, iconSize) => Math.round((wrapperSize - iconSize) / 2 * 10) / 10;
var Icon = _ref => {
  var {
      name,
      width,
      height,
      color,
      className,
      viewBox,
      "data-qa": dataQa = "icon",
      size,
      x = 0,
      y = 0,
      iconsAlternativeConfig,
      iconsSizesConfig
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var iconWidth;
  var iconHeight;
  var href = "#".concat(name);
  var alternatives = _objectSpread(_objectSpread({}, iconsAlternative), iconsAlternativeConfig);
  var sizesConfig = _objectSpread(_objectSpread({}, iconSizes), iconsSizesConfig);
  if (size) {
    if (alternatives[name] && alternatives[name][size]) {
      href = "#".concat(alternatives[name][size]);
    }
    if (sizesConfig[name]) {
      iconWidth = sizesConfig[name][size][0];
      iconHeight = sizesConfig[name][size][1];
    } else {
      iconWidth = defaultSizes[size][0];
      iconHeight = defaultSizes[size][1];
    }
  } else {
    if (width) {
      iconWidth = width;
    } else {
      iconWidth = height || defaultSizes.m[0];
    }
    if (height) {
      iconHeight = height;
    } else {
      iconHeight = width || defaultSizes.m[1];
    }
  }
  var iconViewBox = viewBox || "0 0 ".concat(iconWidth, " ").concat(iconHeight);
  var IconElement = _ref2 => {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
    return /*#__PURE__*/React.createElement("svg", _extends({
      fill: color,
      stroke: color,
      strokeWidth: "0",
      "data-qa": dataQa
    }, props, {
      viewBox: iconViewBox,
      width: iconWidth,
      height: iconHeight
    }, rest), /*#__PURE__*/React.createElement("use", {
      xlinkHref: href,
      href: href
    }));
  };
  return size ? /*#__PURE__*/React.createElement(IconBase, {
    size: size,
    className: className
  }, /*#__PURE__*/React.createElement(IconElement, {
    preserveAspectRatio: "none",
    x: getCoordinate(sizes[size], Number(iconWidth)) + x,
    y: getCoordinate(sizes[size], Number(iconHeight)) + y
  })) : /*#__PURE__*/React.createElement(IconElement, {
    className: className
  });
};
export default Icon;